<template>
  <div class="policy" :class="[
    { 'animate__animated animate__zoomOutLeft': isDeleting },
    { deleting: wasDeleted },
    `offer-${offerTypeColor}`,
  ]">
    <div class="row row--policy box box--default">
      <div class="row__data row__data--small justify-content-center">{{ createdDate }}</div>
      <div class="row__data row__data--medium">{{ offer.policy_offer_name }}</div>
      <div class="row__data row__data--small justify-content-center">{{ offer.status.name }}</div>
      <div class="row__data row__data--medium justify-content-center">{{ user }}</div>
      <div class="row__data row__data--medium justify-content-center">{{ agent }}</div>
      <div class="row__data row__data--medium justify-content-center">

        <div @click="$store.dispatch('reSubmitCustomerOffer', offer)" v-if="!offer.submitted_at && offer.status.id == 3"
          class="icon icon__mail"></div>
        <span v-else>{{ submittedAt }}</span>
      </div>

      <div class="row__data row__data--smaller row__data--pdf"
        :class="offer.files && offer.files.length ? 'icon__pdf--active' : 'icon__pdf'"
        @click="openOfferFilesModal(offer)"></div>

      <div class="row__data row__data--small row__data--edit icon__edit" @click="openOfferModal(offer)"></div>

      <div class="row__data row__data--small row__data--delete icon__delete"
        :class="{ 'icon__delete--active': activeOfferId === offer.id }" tabindex="-1" @focus="activeOfferId = offer.id"
        @focusout="activeOfferId = null" :ref="'delete-' + offer.id">
        <transition name="fade">
          <div class="delete" v-if="activeOfferId == offer.id">
            <div class="delete__text">
              Are you sure you want to delete this offer?
            </div>
            <div class="delete__buttons">
              <div class="button button--confirm" @click="deleteOffer(offer.id)"></div>
              <div class="button button--cancel" @click="closeOfferDeletePopup"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDisplayDate } from "@/helpers/dateFormatters";
import statics from "@/statics";
import { fetchGlobalCustomer } from "@/helpers/accountDetailHelpers";
export default {
  name: "Offer",

  components: {
  },

  props: {
    offer: {
      required: true,
      type: Object,
    },

    index: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      fetchGlobalCustomer,
      formatDisplayDate,
      statics,
      isDeleting: false,
      wasDeleted: false,
      showEditablePopup: false,

      activeOfferId: null,
    };
  },

  computed: {
    createdDate() {
      return this.offer.created_at
        ? this.formatDisplayDate(this.offer.created_at)
        : this.statics.empty;
    },
    submittedAt() {
      return this.offer.submitted_at
        ? this.formatDisplayDate(this.offer.submitted_at)
        : this.statics.empty;
    },

    user() {
      return this.offer.user ? this.offer.user.first_name + " " + this.offer.user.last_name : this.statics.empty;
    },

    agent() {
      return this.offer.agent ? this.offer.agent.first_name + " " + this.offer.agent.last_name : this.statics.empty;
    },

    offerTypeColor() {
      return this.offer.status ? `offer-${this.offer.status.id}` : null;
    },
  },

  methods: {
    closeOfferDeletePopup(offerId) {
      const deleteRef = this.$refs['delete-' + offerId];
      if (deleteRef && deleteRef[0]) {
        deleteRef[0].blur();
      }
      this.activeOfferId = null;
    },

    async deleteOffer(offerId) {
      this.isDeleting = true;
      await this.$store.dispatch("deleteCustomerOffer", { offerId, customerId: this.$route.params.id });
      this.wasDeleted = true;
      setTimeout(async () => {
        await this.$store.dispatch("getCustomerOffers", this.$route.params.id);
      }, 300);
    },

    async changeOfferAgent(agentId) {
      await this.$store.dispatch("updateOfferAgent", {
        offerId: this.offer.id,
        agentId,
      });
      await this.$store.dispatch("getCustomerOffers", this.$route.params.id);
    },

    async updateOfferText(text) {
      await this.$store.dispatch("updateOfferText", {
        offerId: this.offer.id,
        text,
      });
      await this.$store.dispatch("getCustomerOffers", this.$route.params.id);
    },

    downloadPdf(offerId) {
      this.$store.dispatch("downloadOfferDocument", offerId);
    },

    openOfferFilesModal(offer) { 
      const files = [];

      files.push({
        id: `${offer.policy_offer_code}-Offerte_${offer.id}`,
        name: `${offer.policy_offer_code}-Offerte.pdf`,
        file_name: `${offer.policy_offer_code}-Offerte.pdf`,
        created_at: offer.created_at,
        isDownloadable: true,
        offerId: offer.id,
      });

      if (offer.files && Array.isArray(offer.files)) {
        files.push(...offer.files);
      }

      this.$store.commit("setFilesToEditId", offer.id);
      this.$store.commit("setFilesToEdit", files);
      this.$store.commit("setFilesEditMode", 'Offers');
      this.$store.commit("setShowFilesEditModal", true);
    },

    async openOfferModal(offer) {
      this.$store.commit("setOfferToEdit", null);
      this.$store.commit("setShowAddOfferModal", true);
      await this.$store.dispatch("getSpecificOffer", offer.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.delete {
  position: absolute;
  z-index: 3;
  background: var(--bg-1);
  right: calc(3% + 5px);
  top: 25%;
  transform: translateY(-50%);
  width: 300px;
  display: flex;
  align-items: center;
  border-radius: var(--radius-1);
  border: 1px solid var(--border-2);
  padding: 10px 20px;
  box-shadow: 0px 3px 6px var(--shadow-7);

  &__text {
    line-height: 20px;
    color: var(--text-9);
  }

  &__buttons {
    display: flex;
  }

  .button {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: all 0.3s ease;

    &--confirm {
      background: url("../../assets/icons/default/confirm_icon.svg");
      margin: 0 15px;

      &:hover {
        background: url("../../assets/icons/default/confirm_hover_icon.svg");
      }
    }

    &--cancel {
      background: url("../../assets/icons/default/close_icon.svg");

      &:hover {
        background: url("../../assets/icons/default/close_hover_icon.svg");
      }
    }
  }
}

.offer-offer-1::before {
  background-color: #ff3333;
}

.offer-offer-3::before {
  background-color: #FF9E0F;
}

.offer-offer-2::before {
  background-color: #22db8e;
}

.justify-content-center {
  justify-content: center !important;
}

.policy .row__data:first-of-type {
  padding: 0 20px !important;
  padding-right: 5px !important;
}

.row__data--smaller {
  padding: 0 25px !important;
}
</style>
